export function deleteAttachmentIdsReducer(state, action) {
    let newState = [...state];
    return newState.filter(id => !action.payload.attachmentIds.includes(id));
}
//# sourceMappingURL=deleteAttachmentIdsReducer.js.map